import { inject, Injectable } from '@angular/core';
import { SignalClient } from '@digipay/ng-payment';
import { NgxHybridServiceService } from '@digipay/ngx-hybrid-service';
import { checkWealthOrigin } from '../../components/utils/check-wealth-origin';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class BackToOriginService {
  router = inject(Router);
  hybridService = inject(NgxHybridServiceService);

  goBackToOrigin() {
    if (this.hybridService.isHybrid()) {
      this.router.navigate(['']).then();
    } else {
      if (
        checkWealthOrigin() === 'localhost' ||
        checkWealthOrigin() === 'wealth'
      ) {
        window.open(`${window.location.origin}/hub`, '_self');
      } else {
        const redirectUrl = localStorage.getItem('redirectUrl');
        // ? just for development
        if (window.location.origin.includes('localhost')) return;
        if (SignalClient.isSupported()) {
          SignalClient.close('WEALTH');
        } else if (
          redirectUrl?.includes('app.mydigipay.') ||
          redirectUrl?.includes('express.mydigipay.')
        ) {
          localStorage.removeItem('redirectUrl');
          window.open(localStorage.getItem('redirectUrl'), '_self');
        } else {
          window.open(window.location.origin, '_self');
        }
      }
    }
  }
}
